import { useEffect, useState } from 'react';
import { sharedEngine } from '../lib/engine/StockfishEngine';
import type { EngineStatus } from '../types';

/** Expose le statut du moteur partagé et l'instance pour lancer des analyses. */
export function useEngine() {
  const [status, setStatus] = useState<EngineStatus>(sharedEngine.getStatus());

  useEffect(() => sharedEngine.onStatusChange(setStatus), []);

  return { engine: sharedEngine, status };
}
